import React, { useEffect ,useContext, useState} from "react";
import { Dashboard_PortfolioScheme } from "./schema/Dashboard_PortfolioSchema";
import Timer from "../../assets/DashBoard/timer-b.svg";
import RIcon from "../../assets/DashBoard/r-icon.svg";
import HIcon from "../../assets/DashBoard/h-icon.svg";
import JIcon from "../../assets/DashBoard/j-icon.svg";
import IIcon from "../../assets/DashBoard/i-icon.svg";
import RejectionsGraph from "../../assets/DashBoard/graph-b.svg";
import SubscriptionGraph from "../../assets/DashBoard/graph-g.svg";
import DashBoardFooter from "../../assets/DashBoard/dashboard-footer.svg";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";

import { Context } from "../../services/apiContext";
import configData from "../../utils/config/config.json";
import "react-circular-progressbar/dist/styles.css";
import "./css/Dashboard.css";
import DashboardHeader from "./DashboardHeader";
import DashboardPortfolio from "./DashboardPortfolio";
import { useNotificationActionsContext } from "../../components/notificationModal/useModal";


export default function Dashborad() {
  const CurrentValPercentage = 90;
  const totalSubscriptionPercentage = 60;
  const contextapi = useContext(Context);
  const setNotifi = useNotificationActionsContext();
  // const dispatch = useDispatch();
  // const state = useSelector((state) => state);
  // const userAuth = state.authentication;
  // const dashBoard_Details = state?.dashBoardData?.userDashBoard[0];
  // const portfolio_List = state?.dashBoardData?.portfolio;

  // const { access_token, user_key,pan,name } = userAuth.userDetails;
  // const userAuthentication = {
  //   access_token,
  //   user_key,
  //   pan
  // };
  const [userName, setuserName] = useState(contextapi.getSession("userData").name);
  useEffect(() => {
    setuserName(contextapi.getSession("userData").name)
    dashBoardData();
    //  dispatch(getUserDashBoard(userAuthentication))
  }, []);
 
  const [dashboardDetails, setdashboardDetails] = useState({
    total_applns:0,
    total_bids:0,
    not_alloted:0,
    bids_modified:0,
    bids_cancelled:0,
    dividends_recd:0,
    current_value:0,
  })
  const [portFolioDetails, setportFolioDetailsDetails] = useState([])
  const dashBoardData = async () => {
    var useData = contextapi.getSession("userData").user_key;
    var userPan = contextapi.getSession("userData").pan;
  
    var postData = {
      data: {
        user_key: useData,
        pan:userPan
      },
      url: configData.baseURLDev + "/user/userdashboard",
    };
    var url = configData.baseURLProxy;
    await contextapi
      .postApiAuthCalling(url, postData, false)
      .then((res) => {
        console.log(res);
        if (res.msg === "sucess") {
          setdashboardDetails(res.data.dashboard)
          setportFolioDetailsDetails(res.data.portfolio)
          // console.log(res.msg);
          // console.log(dashboardDetails);
        }
      })
      .catch((error) => {
        console.log(error);
        // setNotifi({ val: true, msg: "Something went wrong" });
      });
  };

  return (
    <>
      <div className="col-md-12">
        <nav aria-label="breadcrumb" className="hide-md">
          <ol className="breadcrumb--UnorderList">
            <li className="breadcrumb-item">
              <a href="#">Login</a>
            </li>
            <p className="breadcrumb--Arrow">{">>"}</p>
            <li className="breadcrumb-itemActive" aria-current="page">
              Dashboard
            </li>
          </ol>
        </nav>
      </div>
      {
        dashboardDetails.length > 0 && 
        
        <DashboardHeader response={dashboardDetails} userName={userName}/>
      }
      
      <DashboardPortfolio response={portFolioDetails}/>
      <h5 className="fs-6 mt-3 text-center hide-sm text-upper-case">
        Portfolio
      </h5>
      {/* <div className="row my-3 mx-1 hide-sm round shadow">
        <table className="round">
          <thead>
            <th> Reliance</th>
          </thead>
          <tbody>
            <tr className="d-flex px-2 place-content-space-between">
              <p>Lot Size</p>
              <p>6</p>
            </tr>
            <tr className="d-flex px-2 place-content-space-between">
              <p>Satus</p>
              <p>1,27,753.856</p>
            </tr>
            <tr className="d-flex px-2 place-content-space-between">
              <p>Price</p>
              <p>₹ 235587</p>
            </tr>
            <tr className="d-flex px-2 place-content-space-between">
              <p>Total amount</p>
              <p className="txt-blue b">₹ 3859541.86</p>
            </tr>
          </tbody>
        </table>
      </div> */}
    </>
  );
}